
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import ReCAPTCHA from "react-google-recaptcha";
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "../schema/rustCourseFormSchema";
import { useRef } from "react";

interface ReCaptchaFieldProps {
  form: UseFormReturn<FormValues>;
  siteKey: string;
  onCaptchaChange: (value: string | null) => void;
}

export const ReCaptchaField = ({ form, siteKey, onCaptchaChange }: ReCaptchaFieldProps) => {
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  
  const handleCaptchaChange = async (value: string | null) => {
    // Pass the token to the parent component
    onCaptchaChange(value);
    
    // Update the form field value
    if (value) {
      form.setValue('recaptcha', value, { shouldValidate: true });
    } else {
      form.setValue('recaptcha', "", { shouldValidate: true });
    }
  };
  
  return (
    <FormField
      control={form.control}
      name="recaptcha"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-base font-medium">Verify you're human</FormLabel>
          <FormControl>
            <div className="flex justify-center w-full">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={siteKey}
                onChange={handleCaptchaChange}
              />
              <input
                type="hidden"
                {...field}
              />
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
